import styled from 'styled-components';
import { ReactComponent as PrimeiraMaoSaga } from 'assets/primeira_mao.svg';

export const PrimeiraMaoIcon = styled(PrimeiraMaoSaga)`
  path {
    fill: ${({ color }) => color || 'currentColor'};
  }
`;

export const Iframe = styled('iframe')`
  all: unset;
  width: 100%;
  border: none;
  height: calc(100vh - 240px);
`;
